import './loader.css';

import React from 'react'

function Loader({label}) {
  return (
    <div className='loader-center'>
      <div className='loader-ring'></div>
      <span>{label}</span>
    </div>
  )
}

export default Loader
